module.exports = __webpack_public_path__ + "img/shopping-bag.5ae19946.svg";